import React from 'react';
import { Icon, EeveeIconProps } from '@fuxi/eevee-icon';
import IconSet from '../../assets/iconSet.json';

interface Props {
  name: string;
}

const MyIcon: React.FC<Props & EeveeIconProps> = ({ name, ...resetProps }) => {
  return <Icon iconSet={IconSet} name={name} {...resetProps} />;
};

export default MyIcon;
